import { useGetMileageClaimMileageClaimIdGet } from "@/api-v3";

import { normalizeMileageClaim } from "../helpers/normalize-claim";

import { PaymentFetchView } from "./payment-fetch-view";
import { useCancelableState } from "./use-cancelable-state";

interface MileageFetcherProps {
  id: string;
}

export const MileageFetcher = ({ id }: MileageFetcherProps) => {
  const { data, isLoading, error } = useGetMileageClaimMileageClaimIdGet(id);
  const cancel = useCancelableState("mileage", id);

  return (
    <PaymentFetchView
      isLoading={isLoading}
      error={error}
      view={data ? normalizeMileageClaim(data) : null}
      cancel={cancel}
    />
  );
};
